import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateOrganizationExecutablesUrl } from "../../../config";
import api from "../../../api";
import { Status } from "../../../common/constants";
import { RootState } from "../../../store";
import { IInitialFirmwareVersionSliceState } from "../../../common/types/commonTypes";
const UPDATE_FIRMWARE_VERSION: string = "updateFirmwareVersion";

const initialState: IInitialFirmwareVersionSliceState = {
    msg: "",
    orgId: "",
    show: false,
    status: Status.IDLE,
    error: null,
};

interface IUpdateResponse {
    message: string | null;
}

interface IUpdatePayload {
    orgId: string;
    fileName: string;
    fileType: string;
    version: string;
}

export const updateFirmwareVersion = createAsyncThunk(
    UPDATE_FIRMWARE_VERSION,
    async (payload: IUpdatePayload, { rejectWithValue }) => {
        try {
            const response = await api.post(
                updateOrganizationExecutablesUrl,
                payload
            );
            const updateResponse: IUpdateResponse = response.data;
            return updateResponse;
        } catch (error) {
            throw rejectWithValue(error);
        }
    }
);

const updateFirmwareVersionSlice = createSlice({
    name: UPDATE_FIRMWARE_VERSION,
    initialState,
    reducers: {
        setShow: (state, action) => {
            state.show = action.payload;
        },
        setOrgId: (state, action) => {
            state.orgId = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateFirmwareVersion.pending, (state) => {
                state.status = Status.PENDING;
                state.msg = "";
            })
            .addCase(updateFirmwareVersion.fulfilled, (state) => {
                state.msg = "Updated Successfully";
                state.status = Status.SUCCESS;
            })
            .addCase(updateFirmwareVersion.rejected, (state, action) => {
                const errorPayload = action.payload as {
                    response?: {
                        data?: { error?: { message?: string }; message?: string };
                    };
                };
                state.msg =
                    errorPayload.response?.data?.error?.message ||
                    errorPayload.response?.data?.message ||
                    "Error occurred while updating";
                state.status = Status.FAILED;
            });
    },
});

type Selector = {
    updateOrganizationFirmwareVersion: ReturnType<typeof updateFirmwareVersionSlice.reducer>;
};

export const reducer = updateFirmwareVersionSlice.reducer;
export const { setShow, setOrgId } = updateFirmwareVersionSlice.actions;
export const selector = (store: Selector) => store["updateOrganizationFirmwareVersion"];
